import { SiteIdOverrideConfig } from "stores/wizard/config";
import { TRAVELERS_HIDDEN_INPUT_TYPE } from "components/shared/TravelersField";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";

export const siteId30031: SiteIdOverrideConfig = {
  hotel: {
    date: {
      maxDaysRange: 30,
      daysBookableInAdvance: 330,
      defaultOffsetDates: {
        start: 0,
        end: 1,
      },
    },
    location: {
      destination: {
        labelToken: "hotwire.wizard.hotel.destination.label",
        queryParams: {
          regionId: "",
          latLong: "",
        },
      },
    },
    travelers: {
      labelToken: "hotwire.wizard.roomPicker.travelers.title",
      dialogTitleToken: "hotwire.wizard.roomPicker.travelers.title",
      singleTravelerToken: "hotwire.wizard.roomPicker.singleTraveler",
      multipleTravelersToken: "hotwire.wizard.roomPicker.multipleTravelers",
      singleRoomSingleGuestToken: "hotwire.wizard.roomPicker.singleRoomSingleGuest",
      singleRoomMultipleGuestsToken: "hotwire.wizard.roomPicker.singleRoomMultipleGuests",
      multipleRoomsMultipleGuestsToken: "hotwire.wizard.roomPicker.multipleRoomsMultipleGuests",
      maxBookableTravelers: 24,
      maxAdultsPerRoom: 4,
      maxChildrenPerRoom: 3,
      maxRooms: 6,
      hiddenInputType: TRAVELERS_HIDDEN_INPUT_TYPE.HOTWIRE_HOTEL_SEARCH,
    },
    form: {
      action: "/hotels/search",
    },
  },
  car: {
    location: {
      destination: {
        inputName: "destination",
        labelToken: "hotwire.wizard.car.dropOffLocation.placeholder",
        typeaheadEmptyResultPlaceholder: "hotwire.wizard.car.dropOffLocation.placeholder",
      },
      origin: {
        inputName: "origin",
        labelToken: "hotwire.wizard.car.location.pickUpAndDropOff.label",
        pickUpDropOffLabelToken: "hotwire.wizard.car.location.pickUpAndDropOff.label",
        pickUpLocationLabelToken: "hotwire.wizard.car.pickUp.withHyphen.label",
        typeaheadEmptyResultPlaceholder: "hotwire.wizard.car.pickUpLocation.placeholder",
        differentDropOffToken: "hotwire.wizard.car.different.dropOff.label",
      },
    },
    date: {
      queryParam: {
        start: "",
        end: "",
      },
      daysBookableInAdvance: 330,
      maxDaysRange: 60,
    },
    timeFormats: {
      timeFormat12Hour: true,
    },
    form: {
      action: "/car-rentals/search",
    },
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:00",
    isCarTrawler: false,
    showVendorOptions: false,
    includeGT: false,
  },
};
